import { BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';

import getOrgUnitsByOmeMeetIdAndOmeMeetEntryIdData from './GetOrgUnitsByOmeMeetIdAndOmeMeetEntryIdData';

import Constants from '@usas/ui-web/utils/Constants';

const INITIAL_STATE = {
  ...BASIC_INITIAL_STATE,
  omeMeetId: Constants.DEFAULT_ID,
  omeMeetEntryId: Constants.DEFAULT_ID,
  treeData: []
};

const OrgUnitOmeMeetEntryData = {
  INITIAL_STATE, getOrgUnitsByOmeMeetIdAndOmeMeetEntryIdData
};

export default OrgUnitOmeMeetEntryData;